import { render, staticRenderFns } from "./valva.vue?vue&type=template&id=32414790"
import script from "./valva.vue?vue&type=script&lang=js"
export * from "./valva.vue?vue&type=script&lang=js"
import style0 from "./valva.vue?vue&type=style&index=0&id=32414790&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports